import 'react-app-polyfill/ie11';
import 'custom-event-polyfill';
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import './icons.css';
import './index.css';
import App from './components/AppComponent/App';
import * as serviceWorker from './serviceWorker';
import { loadLiterals } from './redux/reducers';
import loadLang from './i18n/i18n';

loadLang().then(lang => store.dispatch(loadLiterals(lang)));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();